


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SiteEndpointService, SiteQuery, SiteWebAppData } from 'app/core/hub-api';

import { QueryService } from '../../core/services/query.service';

// Queries data from the server (or in memory cache where specified) and allows consumer to subscribe to data changes.
@Injectable()
export class SitesQueryService extends QueryService<SiteWebAppData[]> {

  // This is just the key we will use to look up our single value, we could use anything.
  private key = 'sites';

  constructor(private siteEndpointService: SiteEndpointService) { super(); }

  sitesQuery(useCached: boolean): Observable<SiteWebAppData[]> {
    return super.query(useCached, this.key);
  }

  sitesDataChanges(): Observable<SiteWebAppData[]> {
    return super.cachedDataChanges(this.key);
  }

  protected getDataFromServer(key: string): Observable<SiteWebAppData[]> {
    return this.siteEndpointService.SiteQuery(new SiteQuery());
  }
}
